module.exports = __webpack_public_path__ + "img/zfb_2.9a6636f0.png";